/** Dari / technical labels for C5 fleet UI (inventory / deployments / drift). */

import { cmsStrings } from "../terminology";

export const RING_LABELS: Record<string, string> = {
  pilot: cmsStrings.technical.Pilot,
  canary: cmsStrings.technical.Canary,
  production: "تولید",
};

export const PHASE_LABELS: Record<string, string> = {
  intended: "قصد ثبت‌شده",
  installed_recorded: "نصب ثبت‌شده",
  verified: "تأییدشده",
  superseded: "جایگزین‌شده",
  cancelled: "لغوشده",
};

export const VERIFICATION_LABELS: Record<string, string> = {
  unverified: "تأییدنشده",
  verified_match: "تطبیق",
  verified_mismatch: "عدم تطبیق",
  skipped: "ردشده",
};

export const DRILL_LABELS: Record<string, string> = {
  not_started: "شروع‌نشده",
  drilled: "تمرین انجام‌شد",
  waived: "معاف‌شده",
};

export const DRIFT_KIND_LABELS: Record<string, string> = {
  verified_mismatch: "عدم تطبیق تأییدشده",
  release_mismatch: "نسخه ناهمخوان",
  unverified_stale: "تأییدنشده (بیش از ۷ روز)",
  none: "بدون انحراف",
};

export const PHASE_BADGE_CLASS: Record<string, string> = {
  intended: "scheduled",
  installed_recorded: "pending_approval",
  verified: "published",
  superseded: "archived",
  cancelled: "expired",
};

export const DRIFT_BADGE_CLASS: Record<string, string> = {
  verified_mismatch: "emergency",
  release_mismatch: "paused",
  unverified_stale: "scheduled",
  none: "published",
};
